import getConfig from 'next/config'

import { AlgoliaConfigProviderProps, AlgoliaCrossSellConfig } from '@grandvisionhq/search'

const { algolia } = getConfig().publicRuntimeConfig

const algoliaOptions: AlgoliaConfigProviderProps['options'] = {
  appId: algolia.appId,
  apiKey: algolia.apiKey,
  indexName: algolia.productIndex.name,
  filters: algolia.productIndex.filters,
  sortIndices: algolia.productIndex.sortIndices,
  facets: algolia.productIndex.facets,
  pageSize: algolia.productIndex.pageSize,
}

export function getAlgoliaCrossSellConfig(productType: string): AlgoliaCrossSellConfig {
  const { appId, apiKey } = algoliaOptions
  const { name: indexName, facets } = algolia.crossSellIndex

  return { appId, apiKey, indexName, facets: facets[productType] || {} }
}
